import _slicedToArray from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["## Dependencies"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["## Data"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n----\n## Code"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n## Discussion\n\nThis notebook is a collaboration with [Nan Ma][nan], and is really\njust an offshoot of a project that he has undertaken.\nNan has generated [very complete data][data] for the family of\n[4D star polytopes][stars], including the full topology of cells,\nfaces, edges, and vertices.\nHe is working on preparing his own page to present everything,\nbut he graciously took some time out to export his Mathematica data\nin JSON format, so I could experiment with it here.\n\nThe benefit of \"exploding\" these 4D polytope projections should be\npretty clear; it is effectively impossible to understand the cell\nstructure of the normal, unexploded projections to 3D.\nThe trick for exploding them is one that Nan came up with:\njust find the center of each cell (the centroid of the vertices),\nthen scale that vector up, and add it to all the vertices of the cell\nbefore rendering.\n\nThese polytopes render very naturally with [Zometool][zome],\nSince their 4D vertex coordinates can all be expressed in the Golden field.\nThe only problem for building these in real life is\nthe presence of lots of intersecting struts in the projections.\nOf course, [vZome][vzome] does not care about such intersections,\nany more than the rendering in this notebook does.\n\nI'm delighted to finally have the full structure of the 120-cell as\npart of his data set.  I have rendered the 120-cell in many different\ncontexts, but now, in addition to the ability to explode the cells,\nI can do other fun things like elide sets of cells, select by cell\nin vZome, and so on.\n\n[stars]: https://en.wikipedia.org/wiki/Star_polyhedron#Star_polytopes\n[data]: https://github.com/nanma80/star-polytope\n[nan]: http://nan.ma/\n[vzome]: http://vzome.com\n[zome]: https://zometool.com\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["*Use the mouse and scroll-wheel to rotate, pan, and zoom.*"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["# Exploding 4D Star Polytopes"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// https://observablehq.com/@nanma80/exploding-4d-star-polytopes@300
import define1 from "../@vorth/observable-vzome-rendering.js";
import define2 from "../@vorth/exploring-4d-quaternion-rotations.js";
import define3 from "../@vorth/orbits-of-icosahedral-symmetry.js";
import define4 from "../@jrus/zome-arithmetic.js";
import define5 from "../@jashkenas/inputs.js";
export default function define(runtime, observer) {
  var main = runtime.module();
  main.variable(observer("title")).define("title", ["md"], function (md) {
    return md(_templateObject());
  });
  main.variable(observer("viewof name")).define("viewof name", ["select"], function (select) {
    var dd3 = select({
      title: "Schläfli Symbol",
      description: "Select a 4D polytope",
      options: ["{5,3,3}", "{3,3,5}", "{3,3,5/2}", "{3,5/2,5}", "{3,5,5/2}", "{5/2,3,3}", "{5/2,3,5}", "{5/2,5,3}", "{5/2,5,5/2}", "{5,3,5/2}", "{5,5/2,3}", "{5,5/2,5}"],
      value: "hmmm"
    });
    dd3.input.style.fontSize = "20px";
    dd3.input.style.marginTop = "8px";
    return dd3;
  });
  main.variable(observer("name")).define("name", ["Generators", "viewof name"], function (G, _) {
    return G.input(_);
  });
  main.variable(observer("mainView")).define("mainView", ["explosion", "polytopes", "name", "grmul", "strutScale", "rotated4dViewOriginal", "explode", "polytopeData"], function (explosion, polytopes, name, grmul, strutScale, rotated4dViewOriginal, explode, polytopeData) {
    var explodeAmt = [explosion,, polytopes[name].divisor];
    var strutLength = grmul([2, 3, 1], strutScale);
    return rotated4dViewOriginal(this, explode(polytopeData, explodeAmt), [[[1], [], [], []], [[1], [], [], []], strutLength], {
      renderWidth: 700,
      orbitControl: false
    });
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject2());
  });
  main.variable(observer("viewof explosion")).define("viewof explosion", ["slider"], function (slider) {
    return slider({
      min: 0,
      max: 100,
      step: 1,
      value: 50,
      title: "Explode / Implode",
      description: "Merge or separate the cells"
    });
  });
  main.variable(observer("explosion")).define("explosion", ["Generators", "viewof explosion"], function (G, _) {
    return G.input(_);
  });
  main.variable(observer("viewof strutScale")).define("viewof strutScale", ["phiPowerInput"], function (phiPowerInput) {
    return phiPowerInput(4, {
      title: "Strut Lengths",
      description: "Scale struts relative to balls"
    });
  });
  main.variable(observer("strutScale")).define("strutScale", ["Generators", "viewof strutScale"], function (G, _) {
    return G.input(_);
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject3());
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject4());
  });
  main.variable(observer("explode")).define("explode", ["IndexedSet", "getCellEdges", "centroid", "getEdgesVertices", "scalarmul", "vectoradd", "polytopes", "name"], function (IndexedSet, getCellEdges, centroid, getEdgesVertices, scalarmul, vectoradd, polytopes, name) {
    return function explode(polytope, scale) {
      var newVerts = new IndexedSet();
      var newEdges = [];

      var _loop = function _loop(cellIndex) {
        var cellEdges = getCellEdges(polytope, cellIndex);
        var center = centroid(getEdgesVertices(polytope, cellEdges));
        var newCenter = scalarmul(scale, center);

        function moveVertex(i) {
          var v = polytope.vertices[i];
          return newVerts.add(vectoradd(v, newCenter)); // note side-effect!
        }

        newEdges = newEdges.concat(cellEdges.map(function (e) {
          var _polytope$edges$e = _slicedToArray(polytope.edges[e], 2),
              i = _polytope$edges$e[0],
              j = _polytope$edges$e[1];

          return [moveVertex(i), moveVertex(j)];
        })); // note side-effect!
      };

      for (var cellIndex = 0; cellIndex < polytope.cells.length; cellIndex++) {
        _loop(cellIndex);
      }

      return {
        vertices: polytopes[name].flip ? newVerts.contents.map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 4),
              a = _ref2[0],
              b = _ref2[1],
              c = _ref2[2],
              d = _ref2[3];

          return [b, a, c, d];
        }) : newVerts.contents,
        struts: newEdges.map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              i = _ref4[0],
              j = _ref4[1];

          return {
            start: i,
            end: j
          };
        }),
        balls: newVerts.contents.map(function (d, i) {
          return i;
        })
      };
    };
  });
  main.variable(observer("centroid")).define("centroid", ["vectoradd", "scalarmul"], function (vectoradd, scalarmul) {
    return function centroid(points) {
      var sum = points.reduce(function (total, p) {
        return vectoradd(total, p);
      }, [[], [], [], []]);
      return scalarmul([1,, points.length], sum);
    };
  });
  main.variable(observer("getFaceVertices")).define("getFaceVertices", function () {
    return function getFaceVertices(polytope, face) {
      var dupes = polytope.faces[face].reduce(function (list, edge) {
        return list.concat(polytope.edges[edge]);
      }, []);
      return Array.from(new Set(dupes));
    };
  });
  main.variable(observer("getEdgesVertices")).define("getEdgesVertices", function () {
    return function getEdgesVertices(polytope, edges) {
      var dupes = edges.reduce(function (list, edge) {
        return list.concat(polytope.edges[edge]);
      }, []);
      var indices = Array.from(new Set(dupes));
      return indices.reduce(function (acc, i) {
        acc.push(polytope.vertices[i]);
        return acc;
      }, []);
    };
  });
  main.variable(observer("getCellEdges")).define("getCellEdges", function () {
    return function getCellEdges(polytope, cell) {
      var dupes = polytope.cells[cell].reduce(function (list, face) {
        return list.concat(polytope.faces[face]);
      }, []);
      return Array.from(new Set(dupes));
    };
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject5());
  });
  main.variable(observer("polytopes")).define("polytopes", function () {
    return {
      "{5,3,3}": {
        suffix: "5_3_3_cell120",
        flip: true,
        divisor: 30
      },
      "{3,3,5}": {
        suffix: "3_3_5_cell600",
        flip: true,
        divisor: 15
      },
      "{3,3,5/2}": {
        suffix: "3_3_52",
        flip: false,
        divisor: 2
      },
      "{3,5/2,5}": {
        suffix: "3_52_5",
        flip: false,
        divisor: 5
      },
      "{3,5,5/2}": {
        suffix: "3_5_52",
        flip: false,
        divisor: 15
      },
      "{5/2,3,3}": {
        suffix: "52_3_3",
        flip: true,
        divisor: 2
      },
      "{5/2,3,5}": {
        suffix: "52_3_5",
        flip: true,
        divisor: 10
      },
      "{5/2,5,3}": {
        suffix: "52_5_3",
        flip: true,
        divisor: 15
      },
      "{5/2,5,5/2}": {
        suffix: "52_5_52",
        flip: true,
        divisor: 5
      },
      "{5,3,5/2}": {
        suffix: "5_3_52",
        flip: true,
        divisor: 10
      },
      "{5,5/2,3}": {
        suffix: "5_52_3",
        flip: true,
        divisor: 5
      },
      "{5,5/2,5}": {
        suffix: "5_52_5",
        flip: true,
        divisor: 15
      }
    };
  });
  main.variable(observer("polytopeData")).define("polytopeData", ["polytopes", "name"], function (polytopes, name) {
    return fetch("https://raw.githubusercontent.com/nanma80/star-polytope/master/data/polytope_".concat(polytopes[name].suffix, ".json")).then(function (response) {
      return response.json();
    });
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject6());
  });
  var child1 = runtime.module(define1);
  main.import("phiPowerInput", child1);
  main.import("quaternionInput", child1);
  var child2 = runtime.module(define2);
  main.import("rotated4dViewOriginal", child2);
  main.import("rotated4dViewNoOrbit", child2);
  var child3 = runtime.module(define3);
  main.import("IndexedSet", child3);
  var child4 = runtime.module(define4);
  main.import("scalarmul", child4);
  main.import("vectoradd", child4);
  main.import("grmul", child4);
  var child5 = runtime.module(define5);
  main.import("slider", child5);
  main.import("select", child5);
  return main;
}